import React, {Component} from 'react'
import {Modal} from 'rsuite'

import {StyledButton, StyledConfirmModal} from '../styled/StyledQuestionComponents'
import AlertConfirmIcon from './Icons/AlertConfirmIcon'


class ModalAlertTimeIsOver extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false
        }

    }

    render() {
        return (
            <div className="modal-container">
                <StyledConfirmModal backdrop="static" show={this.props.showConfirmModal}
                                    onHide={() => this.props.closeConfirmModal()} size='xs'>
                    <Modal.Body>
                        <div className={'modal-body'}>
                            <AlertConfirmIcon
                                width={60}
                            />
                            <p>Ops!<strong> Seu tempo acabou!</strong> <br/> Suas respostas foram enviadas.</p>
                        </div>
                    </Modal.Body>
                    {/*<Modal.Footer>*/}
                    {/*    <div className={'modal-footer'}>*/}
                    {/*        <StyledButton*/}
                    {/*            color={'green'}*/}
                    {/*            appearance="defaut"*/}
                    {/*            onClick={() => this.props.closeConfirmModal()}>*/}
                    {/*            Ir para Tela Inicial*/}
                    {/*        </StyledButton>*/}

                    {/*    </div>*/}
                    {/*</Modal.Footer>*/}
                </StyledConfirmModal>
            </div>
        )
    }
}

export default ModalAlertTimeIsOver



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/ModalAlertTimeIsOver.js